import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full" style={{ backgroundColor: '#1a3c34' }}>
      <div className="px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-black font-heading text-white tracking-tight">
                黑料<span style={{ color: '#e07b5a' }}>吃瓜</span>网
              </span>
            </Link>
            <p className="text-sm leading-relaxed" style={{ color: '#b8ccc6' }}>
              黑料吃瓜网 — 全网独家网红黑料、明星塌房现场与每日吃瓜爆料视频聚合平台。
              覆盖51黑料吃瓜、91黑料吃瓜、网曝一区二区等热门入口，一手大瓜立刻开吃。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-5" style={{ color: '#8aaaa0' }}>
              订阅爆料
            </h4>
            <div className="flex items-center border-b pb-2" style={{ borderColor: '#4a7c6f' }}>
              <input
                type="email"
                placeholder="输入邮箱订阅每日爆料"
                className="bg-transparent text-sm text-white placeholder-gray-400 outline-none flex-1"
              />
              <button type="button" className="text-white hover:opacity-75 transition-opacity cursor-pointer">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
            <p className="text-xs mt-2" style={{ color: '#7a9c93' }}>
              订阅即表示同意我们的
              <span className="underline cursor-pointer">隐私政策</span>
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-5" style={{ color: '#8aaaa0' }}>
              快速入口
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { to: '/category/mingxing-tafang', label: '明星塌房' },
                { to: '/category/wanghong-heiliao', label: '网红黑料' },
                { to: '/category/51-heiliao', label: '51黑料吃瓜' },
                { to: '/category/91-heiliao', label: '91黑料吃瓜' },
                { to: '/about', label: '关于我们' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm hover:opacity-75 transition-opacity"
                  style={{ color: '#b8ccc6' }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-5" style={{ color: '#8aaaa0' }}>
              关注我们
            </h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-white cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-white cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-white cursor-pointer" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 md:px-6 pb-10">
        <div className="flex items-end justify-between pt-6 border-t" style={{ borderColor: '#4a7c6f' }}>
          <p className="text-xs" style={{ color: '#7a9c93' }}>
            &copy; {new Date().getFullYear()} 黑料吃瓜网 版权所有
          </p>
          <p className="text-6xl sm:text-7xl md:text-8xl font-black font-heading tracking-tighter opacity-10 text-white select-none leading-none">
            HEILIAO
          </p>
        </div>
      </div>
    </footer>
  );
}